<template>

  <div class="banner">
    <div class="title">
      <span v-if="isAuthenticated">
        <h2>Manager Client</h2>
      </span>
    </div>
    <div class="signature">
      <p>Powered by</p>
      <img class="logo" src="../assets/img/protractor_logo_rev.svg" alt="Protractor">
    </div>
    
  </div>

</template>

<script lang="ts" setup>
import { useAuth0 } from '@auth0/auth0-vue';
import { ref } from 'vue';

const auth0 = useAuth0();
const isAuthenticated = ref(auth0.isAuthenticated);

</script>
